<template>
  <div class="didiPriceRelateOthersSelect">
    <rich-checkbox-group v-model="data" @input="dataChange">
      <div v-for="(item, index) in options" :key="index">
        <rich-checkbox :option="item"/>
        <rich-radio-group :ref="item.value" v-model="remark[item.value]" v-if="item.options && isChecked(item.value)" :options="item.options" @input="remarkChange"></rich-radio-group>
      </div>
    </rich-checkbox-group>
    <div
      class="error-msg"
      v-if="showErr"
      v-text="errmsg"
    ></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        data: [],
        remark: {},
        showErr: false,
        errmsg: this.gettext('选项和输入框不能为空')
      }
    },
    props: {
      options: {},
      value: {
        required: false,
        type: [String, Array, Object]
      }
    },

    created () {
      this.initValue(this.value)
    },
    watch: {
      value (nVal) {
        this.initValue(nVal)
      }
    },
    methods: {
      dataChange () {
        this.change()
      },

      remarkChange () {
        this.change()
      },

      initValue (val = []) {
        const data = []
        val.forEach(item => {
          for (let key in item) {
            data.push(key)
            this.remark[key] = item[key]
          }
        })
        this.data = data
      },
      getValue () {
        const data = []
        this.data.forEach(item => {
          data.push({
            [item]: this.remark[item] || ''
          })
        })
        return data
      },
      change () {
        let value = this.getValue()
        this.$emit('input', value)
      },
      isChecked (value) {
        return this.data.includes(value)
      },
      validate (cb) {
        let value = this.getValue()
        let pass = true
        if (!value) pass = false
        else {
          for (let i = 0; i < value.length; i++) {
            const item = value[i]
            for (let key in item) {
              if (this.$refs && this.$refs[key] && this.$refs[key][0] && !item[key]) {
                pass = false
                break
              }
            }
            if (!pass) break
          }
        }
        cb && pass && cb(pass)
        this.showErr = !pass
        return pass
      }
    }
  }
</script>

<style lang="scss" scoped>
.error-msg {
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}
</style>
